// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-DownloadError----index-module---root---2_lPs","title":"src-components-DownloadError----index-module---title---3OTnt","body":"src-components-DownloadError----index-module---body---2gTAR","button":"src-components-DownloadError----index-module---button---3eIoy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DownloadError/index.module.css
// module id = 602
// module chunks = 114276838955818